import { render, staticRenderFns } from "./DemandDetailPurchaser.vue?vue&type=template&id=9b62f6ac&scoped=true"
import script from "./DemandDetailPurchaser.vue?vue&type=script&lang=js"
export * from "./DemandDetailPurchaser.vue?vue&type=script&lang=js"
import style0 from "./DemandDetailPurchaser.vue?vue&type=style&index=0&id=9b62f6ac&prod&lang=css"
import style1 from "./DemandDetailPurchaser.vue?vue&type=style&index=1&id=9b62f6ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b62f6ac",
  null
  
)

export default component.exports